import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import {
  BlankDashboardComponent,
  DashboardComponent,
  GstComponent,
  OverviewComponent,
  ProductComponent,
  SupplierComponent
} from './components';
import { OwnerDashboardRoutingModule } from './owner-dashboard-routing.module';

@NgModule({
  declarations: [
    BlankDashboardComponent,
    DashboardComponent,
    GstComponent,
    OverviewComponent,
    ProductComponent,
    SupplierComponent
  ],
  imports: [
    OwnerDashboardRoutingModule,
    SharedModule
  ]
})
export class OwnerDashboardModule { }